import React from 'react'
import { imageUrl } from '@libs/appUrl'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;

  amp-carousel {
    background-color: #000;
  }
`

const Page = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  color: #fff;
  text-shadow: 1px 1px 3px #58595b;
`

export function ImageCarousel(props) {
  const { img } = props

  const minAspectRatio = Math.min(...img.map((i) => i.w / i.h))
  const { w: width, h: height } = img.find((i) => i.w / i.h === minAspectRatio)

  return (
    <Container>
      <amp-carousel
        width={width}
        height={height}
        layout="responsive"
        type="slides"
        lightbox
        on="slideChange:AMP.setState({ selectedSlide: event.index })"
      >
        {img.map((item, index) => (
          <amp-img
            key={index}
            src={imageUrl(item.path)}
            width={item.w}
            height={item.h}
            layout="responsive"
          />
        ))}
      </amp-carousel>
      <Page>
        <span data-amp-bind-text="+selectedSlide + 1">1</span>/{img.length}
      </Page>
    </Container>
  )
}

export default ImageCarousel
